'use es6';

import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/PropertyCreation';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
const INIT_STATE = {
  requestStateCreation: RequestState.NOT_REQUESTED,
  creationErrorMessage: '',
  newFieldType: FieldTypes.TEXT
};
export function propertyCreation(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.SUCCEED_CREATING_PROPERTY:
      return Object.assign({}, state, {
        requestStateCreation: RequestState.SUCCEEDED,
        showCreateModal: false
      });
    case Actions.RESET_CREATING_PROPERTY:
      return Object.assign({}, state, {
        requestStateCreation: RequestState.NOT_REQUESTED,
        showCreateModal: false
      });
    case Actions.SET_NEW_FIELD_TYPE:
      return Object.assign({}, state, {
        newFieldType: action.newFieldType
      });
    default:
      return state;
  }
}